let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("l5ej5")).then(() => parcelRequire('GSAjg'));